import { Button, Popover, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useState } from "react";
import { DeleteIcon } from "../../../shared/views/icons";
import { CustomPopover } from "../../../shared/views/CustomPopover";

type Props = {
  onDelete: () => Promise<void>;
};

const WayDetailDeleteBase = ({ onDelete }: Props) => {
  const [deleting, setDeleting] = useState(false);

  return (
    <CustomPopover
      trigger={
        <Button colorPalette="red" fontSize="sm" size="sm" variant="plain">
          <DeleteIcon /> Delete
        </Button>
      }
    >
      <Popover.Body>
        <Stack gap={4}>
          <Text textStyle="label">Are you sure?</Text>
        </Stack>
      </Popover.Body>

      <Popover.Footer justifyContent="end">
        <Button
          loading={deleting}
          colorPalette="red"
          fontSize="sm"
          size="sm"
          onClick={async () => {
            setDeleting(true);
            try {
              await onDelete();
            } finally {
              setDeleting(false);
            }
          }}
        >
          Delete
        </Button>
      </Popover.Footer>
    </CustomPopover>
  );
};

export const WayDetailDelete = observer(WayDetailDeleteBase);
